import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
	return (
		<nav className="sidebar">
			<h2>Essentials</h2>
			<div className="scroll">

				<div className="nav-links">
					<div className="nav-link">
						<NavLink exact to={'/getting-started'}>Getting Started</NavLink>
					</div>
					<div className="nav-link">
						<NavLink to={'/getting-started/server-authentication'}>Server Authentication</NavLink>
					</div>
					<div className="nav-link">
						<NavLink to={'/getting-started/client-authentication'}>Client Authentication</NavLink>
					</div>
					<div className="nav-link">
						<NavLink to={'/getting-started/common-objects'}>Common Objects</NavLink>
					</div>
					<div className="nav-link">
						<NavLink to={'/getting-started/making-a-request'}>Making a Request</NavLink>
					</div>
					<div className="nav-link">
						<NavLink to={'/getting-started/rate-limiting'}>Rate Limiting</NavLink>
					</div>
				</div>

				{/* TODO - THIS SECTION NEEDS A LOT OF TLC!!! */}
				<h2>Example Use Cases</h2>
				<div className="nav-links">
					<div className="nav-link">
						<NavLink to={'/getting-started/simple-tasks'}>Simple Tasks</NavLink>
						<div className="route-links">
							<NavLink activeClassName="active-route" to={'/getting-started/simple-tasks/get-user'}>Get a User</NavLink>
							<NavLink activeClassName="active-route" to={'/getting-started/simple-tasks/get-post'}>Get a Post</NavLink>
							{/*<NavLink activeClassName="active-route" to={'/getting-started/simple-tasks/get-stream'}>Get a Stream</NavLink>*/}
							<NavLink activeClassName="active-route" to={'/getting-started/simple-tasks/manage-targets'}> Manage Targets</NavLink>
							<NavLink activeClassName="active-route" to={'/getting-started/simple-tasks/preregister-user'}>Preregister a User</NavLink>
							<NavLink activeClassName="active-route" to={'/getting-started/simple-tasks/share-post'}>Share a Post</NavLink>
							<NavLink activeClassName="active-route" to={'/getting-started/simple-tasks/update-user'}>Update a User</NavLink>
							<NavLink activeClassName="active-route" to={'/getting-started/simple-tasks/upload-profile-image'}>Upload a Profile Image</NavLink>
							<NavLink activeClassName="active-route" to={'/getting-started/simple-tasks/upload-video'}>Upload a Video</NavLink>
						</div>
					</div>
				</div>

				<h2>Misc. Topics</h2>
				<div className="nav-links">
					<div className="nav-link">
						<NavLink to={'/getting-started/post-routing'}>Post Routing</NavLink>
					</div>
					<div className="nav-link">
						<NavLink to={'/getting-started/json-data-types'}>JSON Data Types</NavLink>
					</div>
					<div className="nav-link">
						<NavLink to={'/getting-started/image-formats'}>Image Formats</NavLink>
					</div>
					<div className="nav-link">
						<NavLink to={'/getting-started/cors'}>CORS</NavLink>
					</div>
				</div>

				<h2>Advanced Topics </h2>
				<div className="nav-links">
					<div className="nav-link">
						<NavLink to={'/getting-started/batch-requests'}>Batch Requests</NavLink>
					</div>
					<div className="nav-link">
						<NavLink to={'/getting-started/continuable-list'}>Continuable List Responses</NavLink>
					</div>
				</div>
			</div>
		</nav>
	);
};

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/getting-started/Sidebar.js